module.exports = __webpack_public_path__ + "static/media/corporate-services-img45.417c6b66.jpg";